import { batch, connect } from 'react-redux';

import {
  actions as filterActions,
  selectTotalSelectedFilterOptionsCount,
} from 'src/components/organisms/Filter';
import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { updateFilters, UpdateFiltersActionType } from 'src/redux/products';
import { AppThunkDispatch } from 'src/redux/store';
import { FilterMenu } from '../components/FilterMenu';
import { selectSelectedSortingOptionInSentenceCase } from '../modules/selectors';
import { actions as filterMenuActions } from '../modules/slice';

export const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
  openFilterModal: () => dispatch(filterActions.openModal()),
  openSortByModal: () => dispatch(filterMenuActions.openModal()),
  onResetFilters: () => {
    batch(() => {
      dispatch(filterActions.resetFilters());
      dispatch(filterMenuActions.resetSelectedSortOption());
      dispatch(updateFilters(UpdateFiltersActionType.FILTER));
    });
  },
});

export const mapStateToProps = (state: ReduxApplicationState) => ({
  totalSelectedFilterOptionsCount: selectTotalSelectedFilterOptionsCount(state),
  totalProducts: state.products.totalProducts,
  selectedSortOption: selectSelectedSortingOptionInSentenceCase(state),
});

export const FilterMenuContainer = connect(mapStateToProps, mapDispatchToProps)(FilterMenu);
